import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../../core/models/response-service.model';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class LeadService {
	constructor(
		private http: HttpClient,
		private dataService: OldDataService,
		private utils: UtilsService,
	) {}

	public leads_by_user(userId: number, dateStart: string, dateEnd: string) {
		if (dateStart == '') {
			dateStart = '-';
		}
		if (dateEnd == '') {
			dateEnd = '-';
		}

		const url = `${environment.api}lead/get_leads_user/${userId}/${dateStart}/${dateEnd}`;
		return this.http.get(url);
	}

	public lead_detail(lead_id: number) {
		const url = `${environment.api}lead/${lead_id}/get_lead_by_id`;
		return this.http.get<ResponseService>(url);
	}

	public report_leads_home(userId: number) {
		const url = `${environment.api}lead/get_leads_report_home/${userId}`;
		return this.http.get<ResponseService>(url);
	}

	public get_customer_notes_bylead(lead: number) {
		const url = `${environment.api}lead/get_customer_notes_bylead/${lead}`;
		return this.http.get<ResponseService>(url);
	}

	saveNotes(leadId: number, notes: string) {
		var formData: any = new FormData();
		formData.append('LeadId', leadId);
		formData.append('Notes', notes);

		const url = `${environment.api}lead/save_lead_notes`;
		var response = this.http.post<ResponseService>(url, formData);
		return response;
	}

	saveFeedBack(leadId: number, feedback: string, satisfaction: number) {
		var formData: any = new FormData();
		formData.append('LeadId', leadId);
		formData.append('Feedback', feedback);
		formData.append('Satisfaction', satisfaction);

		const url = `${environment.api}lead/save_lead_feedback`;
		var response = this.http.post<ResponseService>(url, formData);
		return response;
	}

	public obteinFeedback(lead: number) {
		const url = `${environment.api}lead/get_lead_feedback/${lead}`;
		return this.http.get<ResponseService>(url);
	}

	public confirmLeadReceived(lead: string) {
		const url = `${environment.api}lead/confirm_lead/${lead}`;
		return this.http.get<ResponseService>(url);
	}

	public confirmLeadReceivedBak(lead: string, dateReceived: string) {
		const url = `${environment.api}lead/${lead}/${dateReceived}/confirm_lead`;
		return this.http.get<ResponseService>(url);
	}

	public send_survey(id, prospect_company, start_date, start_time, campaign_name, email, email_user) {
		const url = `${environment.api}lead/send_survey`;
		const payload = { id: id, prospect_company: prospect_company, start_date: start_date, start_time: start_time, campaign_name: campaign_name, email_prospect: email, email_client: email_user };
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	saveClientNotesByLead(leadId: number, notes: string, client: boolean) {
		var formData: any = new FormData();
		formData.append('LeadId', leadId);
		formData.append('Notes', notes);
		formData.append('Client', client);

		const url = `${environment.api}lead/save_client_notes_bylead`;
		var response = this.http.post<ResponseService>(url, formData);
		return response;
	}

	public obteinFiles(lead: number) {
		const url = `${environment.api}lead/lead_files/${lead}`;
		return this.http.get<ResponseService>(url);
	}
	/*Data for dashboard*/
	//numbers of lead
	public numbers_of_lead(userId: number) {
		const url = `${environment.api}lead/get_numbers_lead/${userId}`;
		return this.http.get<ResponseService>(url);
	}
	//amount of lead
	public feedback_of_user(userId: number) {
		const url = `${environment.api}lead/get_feedback_avg_user/${userId}`;
		return this.http.get<ResponseService>(url);
	}

	public send_calendar_invite(datos: any) {
		// const url = 'https://hooks.zapier.com/hooks/catch/2314556/3cx31jd/';

		const webhookUrl = 'https://hooks.zapier.com/hooks/catch/16933651/3p1fvj1/';
		return this.http.post(webhookUrl, { id: 'xxx', ppp: 'ssss' });
	}

	public selectSearch(payload) {
		const url = `${environment.api}lead/select_search`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	public getAllUnreviewed() {
		const url = `${environment.api}lead/get_all_unreviewed`;
		return this.http.get<ResponseService>(url);
	}

	public approve_lead(payload) {
		const url = `${environment.api}lead/approve_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getLeadCampaign(lead_id) {
		const url = `${environment.api}lead/${lead_id}/get_campaign_by_lead`;
		return this.dataService.get(url);
	}

	fixLead(payload) {
		const url = `${environment.api}lead/fix_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	denyLead(payload) {
		const url = `${environment.api}lead/deny_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	setReplacementStatus(payload) {
		const url = `${environment.api}lead/set_replacement_status`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	replaceLeadBy(payload) {
		const url = `${environment.api}lead/replace_lead_by`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	unreplaceLead(lead_id, user_id) {
		const url = `${environment.api}lead/${lead_id}/${user_id}/unreplace_lead`;
		return this.http.get<ResponseService>(url);
	}

	saveAll(payload) {
		const url = `${environment.api}lead/save_all`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	confirmLead(payload) {
		const url = `${environment.api}lead/confirm_lead`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	saveClientNotes(payload) {
		const url = `${environment.api}lead/save_client_notes`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getLeadHistory(lead_id) {
		const url = `${environment.api}lead/${lead_id}/get_lead_history`;
		return this.http.get<ResponseService>(url);
	}

	getLeadAttachments(lead_id) {
		const url = `${environment.api}lead/${lead_id}/get_attachments`;
		return this.http.get<ResponseService>(url);
	}

	downloadFile(payload) {
		const url = `${environment.api}lead/download_file`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	uploadFile(formData) {
		const url = `${environment.api}lead/upload_files`;
		return this.http.post(url, formData);
	}

	deleteFile(payload) {
		const url = `${environment.api}lead/delete_file`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	rescheduleQa(payload) {
		const url = `${environment.api}lead/reschedule_qa`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getPossibleReplacements(alias) {
		//lead/$alias/get_possible_replacements
		const url = `${environment.api}lead/${alias}/get_possible_replacements`;
		return this.http.get<ResponseService>(url);
	}

	getAllPayedChargeBacks(payload) {
		const url = `${environment.api}chargebacks/get_all_payed`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getDispoLogNotes(prospect_id) {
		const url = `${environment.api}lead/${prospect_id}/get_dispo_log_notes`;
		return this.http.get<ResponseService>(url);
	}

	getQcLeadNotes(lead_id) {
		const url = `${environment.api}lead/${lead_id}/get_qc_lead_notes`;
		return this.http.get<ResponseService>(url);
	}

	resendLeadApprovedEmail(payload) {
		const url = `${environment.api}lead/resend_approved_lead_email`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	public saveLeadLifecycle(payload: any) {
		const url = `${environment.api}leadlifecycle/create`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	public getLeadLifecycle(leadId: number) {
		const url = `${environment.api}leadlifecycle/${leadId}/get`;
		return this.http.get<ResponseService>(url);
	}
}
